var _defs, _rect, _path, _path2, _path3, _rect2, _text, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerVerSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "44px",
    height: "27px",
    viewBox: "-0.5 -0.5 44 27",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-12-24T07:05:53.618Z\" agent=\"5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/96.0.4664.110 Safari/537.36\" version=\"16.0.3\" etag=\"9FUzf4IEH8z9SStYbx29\" type=\"google\"><diagram id=\"trhxXo6r6w81gK26jna9\">rVZNc5swEP01HMMIBBiOsZO0h3YmMzn0rIIMGgtEhYhxfn1XSOLDOFNnpvLB0tvV7mr37doePtTDN0na6qcoKPdCVAwefvLCMMEohi+NXAwS7KLQIKVkhcVm4I19UAsii/asoN1KUQnBFWvXYC6ahuZqhREpxXmtdhR87bUlJd0AbznhW/QXK1Rl0DRGM/6dsrJyngNkJTVxyhboKlKI8wLCzx4+SCGU2dXDgXKdPZcXc+/lE+kUmKSNuueCzfs74b19m41LXdxjuxNVuY4aeXhPutYk9MgGCjb2rWCNovL5HRzqrAaATY/SNwrSVVpzPFSq5k5JSXGiB8GFBKQRDbjbc/Kb8lfRMcVEA3BOtXEQvFOpGBTgx5XCb6GUqBcKj5yVWqBEq8O1p8nOkXHufHohNsuE3Or31kOpOeuTj15SPxd125uLY2R7kp9KKfqmuIr7KBplaRrE9rxw8zIuwG22IVY6fFqxYOIBdBAVNVXyAir2wkOQJchHKNylKMrSIDMGXCvhLPFDhNIki5MYOgsb8XmmaZD6URxmSZalKMVpiiOjUi0Zm/gJSnAURbsY/GU4tc1jG6ecwpq5BRtLr9tUw/+mGm2KR92eurBc5Kc1Y8bET1Rapjzcpvwwrg3PQJKMCyTg7YVxZ90EQ4tN599dmBivSvGA/ThbLJRtSuEGxjL1DruVauv7VffcihF47TqIUOBHazud6GVO7dXlRLjHWnZtTRFZUrWxBtUjl4XaOB26L4WOM+fsSxEG60uwMbHM1JwqdhdboxtsTbiyRFvRNvnTCyd46EZKPoJC2g6zDHal/h6cFfBvDBl80wowINQdA3M5zyy0mXnXo7FmRaHd7M8VU/StJbn2eYa5t2my+6fejRaMnvTnv029cOdHm2EX+eF2wN3oqgA7xS+MMDjOv8SGQ/MfGvz8Fw==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 4.2,
    width: 18.45,
    height: 16.61,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0.86 17.32 C 0.61 17.3 0.38 17.18 0.23 16.99 C 0.07 16.81 0 16.57 0.02 16.33 L 0.02 5.13 C 0.06 4.66 0.42 4.29 0.89 4.22 L 17.39 4.22 C 17.94 4.2 18.4 4.6 18.45 5.13 L 18.43 16.51 C 18.32 16.99 17.9 17.34 17.39 17.36 L 11.61 17.36 L 11.35 18.39 C 11.29 18.62 11.33 18.88 11.46 19.08 C 11.6 19.29 11.81 19.44 12.05 19.49 C 12.61 19.67 13.21 19.75 13.8 19.72 L 14.87 19.72 L 14.87 20.81 L 2.84 20.81 L 2.84 19.72 L 4.12 19.72 C 4.79 19.73 5.45 19.62 6.09 19.4 C 6.58 19.28 6.89 18.8 6.77 18.31 L 6.6 17.36 Z M 1.4 16.02 L 17.02 16.02 L 17.02 5.61 L 1.4 5.61 Z",
    fill: "#333333",
    stroke: "none",
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 27 9.4 L 27 7.4 L 27 9.4 L 27 9.28",
    fill: "none",
    stroke: "#666666",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 27 16.28 L 23.5 9.28 L 30.5 9.28 Z",
    fill: "#666666",
    stroke: "#666666",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.51,
    y: 2.2,
    width: 10,
    height: 13.2,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 8,
      height: 1,
      paddingTop: 9,
      marginLeft: 34
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #4D4D4D; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(77, 77, 77)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 8
    }
  }, "x"))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 12,
    fill: "#4D4D4D",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "x"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerVerSvg);
export default __webpack_public_path__ + "static/media/computer-ver-svg.4d7db017f444271c5af57bd1f5565f39.svg";
export { ForwardRef as ReactComponent };